import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Artifact, XmlArtifact } from '../../models/artifact';
import { DxDataGridModule } from 'devextreme-angular';
import { DxoSelectionModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';


@Component({
    selector: 'app-xml-artifact-grid',
    templateUrl: './xml-artifact-grid.component.html',
    styleUrls: ['./xml-artifact-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, DxoSelectionModule, DxiColumnModule, DxTemplateModule]
})
export class XmlArtifactGridComponent implements OnInit {

    @Input() artifacts: XmlArtifact[] = [];

    constructor(public modal: NgbActiveModal) {}

    async ngOnInit(): Promise<void> {
    }

    calculateIsNewColumnValue(rowData: Artifact) {
        return !rowData.ArtifactId;
    }
}
